import { useI18n } from "@/i18n";
import { LogoMark } from "./Logo";

export const Marquee = () => {
  const { t } = useI18n();
  return (
    <section aria-label="Activities" data-testid="marquee" className="marquee-wrap overflow-hidden border-y border-white/10 bg-ink py-7 lg:py-10">
      <div className="marquee-track flex w-max">
        {[0, 1].map((copy) => (
          <div key={copy} aria-hidden={copy === 1} className="flex shrink-0 items-center">
            {t.marquee.map((item, i) => (
              <span key={item} className="flex items-center">
                <span className={`whitespace-nowrap px-6 font-display text-4xl font-medium tracking-tight sm:text-5xl lg:px-10 lg:text-7xl ${i % 2 ? "stroke-text" : "text-bone"}`}>{item}</span>
                <LogoMark className="h-6 w-6 text-zinc-600 lg:h-8 lg:w-8" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
};
